<script setup lang="ts">
import { DataGrid } from '@dashhudson/dashing-ui/data-grid';
import { computed } from 'vue';

import MediaCard from '@/components/dashingUI/MediaCard.vue';
import { VISION_AI_SUMMARY_INTERACTIONS } from '@/components/VisionAi/constants';
import type {
  LibraryMediaWidgetData,
  VisionAiWidgetClickPayload,
} from '@/components/VisionAi/widgets/visionWidget.types';
import { useVisionAiStore } from '@/stores/vision-ai';

const emit = defineEmits<{
  onWidgetClick: [payload: VisionAiWidgetClickPayload];
}>();

const props = withDefaults(
  defineProps<{
    widgetData: LibraryMediaWidgetData;
    narrowMode?: boolean;
  }>(),
  { narrowMode: false },
);

const visionAiStore = useVisionAiStore();

const mediaItems = computed(() => props.widgetData?.media_items ?? []);

function onCardClick() {
  emit('onWidgetClick', { interaction: VISION_AI_SUMMARY_INTERACTIONS.POST_CLICK });
  visionAiStore.closeChatWindow();
}
</script>

<template>
  <MediaCard
    v-if="mediaItems.length === 1"
    :media="mediaItems[0]"
    show-user-details
    class="max-w-[260px]! min-w-[189px]! flex-[1_1_200px]!"
    data-testid="library-media-widget"
    @click="onCardClick"
  />
  <DataGrid
    v-else-if="mediaItems.length > 1"
    :value="mediaItems"
    data-key="source_id"
    grid-layout-preset="MediaCard"
    class="w-full!"
    data-testid="library-media-widget"
  >
    <template #item="{ data }">
      <MediaCard :media="data" show-user-details @click="onCardClick" />
    </template>
  </DataGrid>
</template>
